import { Injectable } from "@angular/core";
import { RestResponse } from "../models/RestResponse";
import { RestClientService } from "./restclient.service";
import { Observable } from "rxjs";
import { AuthenticateModel } from "../models/authenticateModel";
import { QueryModel } from "../models/queryModel";
import { AuthTokenService } from "./auth-token.service";

@Injectable()
export class UserService {
  constructor(
    private restClientService: RestClientService,
    private authService: AuthTokenService
  ) { }
  public authenticate(model: AuthenticateModel): Observable<any> {
    //console.log("Before Authentication" + JSON.stringify(model));

    // console.log(model)
    let url = "/ws_portal.php";
    return this.restClientService.HttpPost(model, url, false, true);
  }
  public GetMethod(model: any): Observable<any> {
    // console.log(JSON.stringify(model))
    let url = "/ws_portal.php";
    return this.restClientService.HttpPost(model, url, false, true);
  }
}
